
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_1ndao_141",
  "button": "awsui_button_fvjdu_1ndao_182",
  "dots": "awsui_dots_fvjdu_1ndao_183",
  "button-disabled": "awsui_button-disabled_fvjdu_1ndao_211",
  "arrow": "awsui_arrow_fvjdu_1ndao_216",
  "page-number": "awsui_page-number_fvjdu_1ndao_226",
  "button-current": "awsui_button-current_fvjdu_1ndao_232",
  "jump-to-page": "awsui_jump-to-page_fvjdu_1ndao_245",
  "jump-to-page-input": "awsui_jump-to-page-input_fvjdu_1ndao_253",
  "pages-compact": "awsui_pages-compact_fvjdu_1ndao_263",
  "page-item": "awsui_page-item_fvjdu_1ndao_268",
  "root-disabled": "awsui_root-disabled_fvjdu_1ndao_289"
};
  